<template>
  <div class="modal animated is-active" v-if="payment_methods">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">Pay Selected Invoices</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Payment Method</label>
              <select name="bank" id="payment_methods" v-model="payment.payment_method" class="select is-fullwidth" @change="setCurrency()">
                <option value="">Select Payment Method</option>
                <option v-for="payment_method in payment_methods" v-bind:value="payment_method">{{ parsePaymentMethod(payment_method) }}</option>
              </select>
            </p>
          </div>
          <template v-if="payment.payment_method != null && payment.payment_method != 'credit' && payment.payment_method != ''">
            <div class="control is-grouped">
              <p class="control is-expanded" v-show="currency.length === 1">
                <label class="label">Amount</label>
                <input class="input is-disabled" name="amount" id="amount" type="text" placeholder="" v-model="payment.amount">
              </p>
              <p class="control is-expanded">
                <label class="label">Currency</label>
                <select class="select is-fullwidth" v-model="payment.payment_currency" name="currency" id="currency">
                  <option v-for="currency in currencies" v-bind:value="currency.currency">{{currency.currency}}</option>
                </select>
              </p>
              <p class="control is-expanded" v-show="currency[0] !== payment.payment_currency">
                <label class="label">Exchange</label>
                <input :class="{'input': true, 'is-danger': errors.has('exchange')}" name="exchange" id="exchange" type="text" placeholder="" v-model="payment.exchange" v-validate="'required|decimal:8'" @change="setTotal()">
                <span v-show="errors.has('exchange')" class="help is-danger">{{ errors.first('exchange') }}</span>
              </p>
              <p class="control is-expanded" v-if="currency[0] != payment.payment_currency" v-show="currency.length === 1">
                <label class="label">IOF</label>
                <input class="input is-disabled" name="iof" id="iof" type="text" placeholder="" v-model="payment.iof">
              </p>
              <p class="control is-expanded" v-if="currency[0] != payment.payment_currency" v-show="currency.length === 1">
                <label class="label">Total</label>
                <input class="input is-disabled" name="total" id="total" type="text" placeholder="" v-model="payment.total">
              </p>
              <p class="control is-expanded">
                <label class="label">Date</label>
                <datepicker ref="depositDate" placeholder="Date"></datepicker>
              </p>
            </div>
          </template>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a class="button is-primary" @click="close(true)">Cancel</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any() || inProgress || payment.payment_method == null || (payment.accountSub == null && payment.payment_method === 'credit'), 'is-loading': inProgress}" @click="pay()">Pay</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import Datepicker from 'vue-bulma-datepicker'
  export default {
    props: {
      context: {
        type: Object
      },
      invoice: {
        type: Array,
        required: true
      },
      currency: {
        type: Array,
        required: true
      },
      amount: {
        type: Number,
        required: false
      },
      callback: {
        type: String
      }
    },
    data () {
      return {
        payment: {
          payment_method: '',
          payment_currency: '',
          currency: '',
          amount: 0,
          exchange: 1,
          date: '',
          total: 0,
          iof: 0,
          iofPercent: 0,
          accountSub: null
        },
        payment_methods: null,
        accountsSub: null,
        inProgress: false,
        error: '',
        remove_user_id: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
        this.loadMethods()
        this.payment.invoice_id = this.invoice
        this.payment.amount = this.amount
        this.context.$http.get(this.context.$store.state.config.apiURL + '/config/iof')
          .then((response) => {
            // console.log('Body iof : ' + response.body.iof)
            this.iofPercent = response.body.iof
            // console.log('iof percent : ' + this.iofPercent)
          })
      })
    },
    methods: {
      loadMethods () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/payment_methods', {params: { type: 0 }}).then((response) => {
          this.payment_methods = response.body
        }, (response) => {
        })
      },
      loadClientCredit () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/account/credits/client', {params: { base_id: this.invoice.base_id, agency_id: this.invoice.agency_id }}).then((response) => {
          this.accountsSub = response.body
        }, (response) => {
        })
      },
      parsePaymentMethod (method) {
        let methodName = ''
        if (parseInt(method.method_type) === 1) {
          methodName = 'CARD - ' + method.card_number + ' - ' + method.card_flag
        } else {
          methodName = 'BANK - ' + method.bank
          if (method.account !== null) {
            methodName = methodName + ' - ' + method.account
          }
          if (method.agency !== null) {
            methodName = methodName + ' - ' + method.agency
          }
        }
        return methodName
      },
      setCurrency () {
        if ((this.payment_methods !== null) && (this.payment_methods !== '')) {
          this.currencies = this.payment.payment_method.currencies
          let exist = false
          for (let x = 0; x < this.payment.payment_method.currencies.length; x++) {
            if (this.payment.payment_method.currencies[x].currency === this.currency) {
              exist = true
            }
          }
          if (exist) {
            this.payment.payment_currency = this.currency
          } else {
            this.payment.payment_currency = this.payment.payment_method.currencies[0].currency
          }
        }
      },
      setTotal () {
        this.payment.iof = parseFloat((this.payment.amount * this.payment.exchange * this.iofPercent)).toFixed(2)
        this.payment.total = (parseFloat(this.payment.amount * this.payment.exchange) + parseFloat(this.payment.iof)).toFixed(2)
      },
      close (closeOnly, result) {
        if (closeOnly) {
          this.remove_user_id = 1
          this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/invoice/set_editing_user', {invoice_id: this.payment.invoice_id, remove_user_id: this.remove_user_id}).then((response) => {
          }, (response) => {
            this.error = response.body
          })

          this.context[this.callback](closeOnly)
        } else {
          this.context[this.callback](closeOnly)
        }
        this.remove_user_id = ''
        this.$el.remove()
      },
      pay () {
        this.inProgress = true
        this.payment.currency = this.currency
        if (this.payment.payment_method === '') {
          this.error = 'Please set payment method!'
          this.inProgress = false
          return false
        }
        let depositDate = this.$refs.depositDate.datepicker.input.value
        this.payment.date = depositDate
        if ((this.currency !== this.payment.payment_currency) && (this.payment.exchange === 0)) {
          this.error = 'Please set exchange!'
          this.inProgress = false
          return false
        }
        if (this.$refs.depositDate.datepicker.input.value === '') {
          this.error = 'Please select date!'
          this.inProgress = false
          return false
        } else {
          this.error = ''
          if (window.confirm('Are you sure you want to pay?')) {
            this.context.$http.post(this.context.$store.state.config.apiURL + '/V2/invoice/pay', this.payment).then((response) => {
              this.inProgress = false
              this.close(false, 'ok')
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          } else {
            this.inProgress = false
          }
        }
      }
    },
    components: {
      Datepicker
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// PayInvoice.vue?144bc050